module.exports = __webpack_public_path__ + "img/free-standing-wall-5.60143277.jpeg";